import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import "../App.css";
import Header from "../components/Header/Header";
import Main from "../components/Mainhome/Main";
import Footer from "../components/Footer/Footer";
import FormHelp from "../components/FormHelp/FormHelp";
import Requisites from "../components/Requisites";

export const Home = () => {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    document.title = t("meta.home.title");

    const metaDescription = document.querySelector("meta[name='description']");
    const content = t("meta.home.description");

    if (metaDescription) {
      metaDescription.setAttribute("content", content);
    } else {
      const meta = document.createElement("meta");
      meta.name = "description";
      meta.content = content;
      document.head.appendChild(meta);
    }
  }, [i18n.language]);

  return (
    <div className="Home page">
      <FormHelp />
      <Requisites />
      <div id="homepage" className="">
        <Header />
        <Main />
        <Footer />
      </div>
    </div>
  );
};